export const api = "https://hiredevs-api.onrender.com";
// 'https://apihiredevs.herokuapp.com'
// 'http://localhost:8080'
// https://hiredevs-api.onrender.com
